export const MENU_IDS = {
  DETAILS: 'details',
  INSURANCE: 'insurance',
  LIST_APPS: 'list-apps',
  NEW_APP: 'new-app',
  REPORTS: 'reports',
};

export const DATA_TESTS = {
  [MENU_IDS.DETAILS]: 'openDetailsPage',
  [MENU_IDS.INSURANCE]: 'openInsuranceCreationPage',
  [MENU_IDS.LIST_APPS]: 'openListAppsPage',
  [MENU_IDS.NEW_APP]: 'openCreditCreationPage',
  [MENU_IDS.REPORTS]: 'openReportsPage',
};
